import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setNavbarType } from '../../features/navbar-type/actions';
import CSS from './NewNavToggler.module.css';
import PdxToggleSwitch from './PdxToggleSwitch/PdxToggleSwitch';
import { AnalyticsContext } from '../Analytics/Provider';
import { EVENTS } from '../Analytics/config';

export const NewNavTogglerComponent = ({
  legacy,
  onChange,
}) => {
  const analytics = useContext(AnalyticsContext);
  const event = legacy ? EVENTS.TURN_ON_NEW_NAV : EVENTS.TURN_OFF_NEW_NAV;
  return (
    <div className={`${CSS['new-nav-toggler']} ${legacy ? ` ${CSS['legacy-padding']}` : ''}`}>
      <PdxToggleSwitch
        id="newNavToggler"
        label="New navigation"
        checked={!legacy}
        onChange={(e) => {
          onChange(e);
          analytics.track(event);
        }}
      />
    </div>
  );
};

NewNavTogglerComponent.defaultProps = {
  legacy: false
};

NewNavTogglerComponent.propTypes = {
  legacy: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: () => (ownProps.legacy ? dispatch(setNavbarType('jobstobedone')) : dispatch(setNavbarType('legacy')))
});

export default connect(null, mapDispatchToProps)(NewNavTogglerComponent);
